<ng-template #title>
  <ng-content select="cap-title"></ng-content>
</ng-template>

<ng-container *ngTemplateOutlet="title" class="sr-only"></ng-container>
@if (!disableBreadcrumb) {
  <cap-breadcrumb></cap-breadcrumb>
}
<ng-container>
  <cap-alert-list [alertLevel]="alertLevelContentHeader"></cap-alert-list>
</ng-container>

<div class="row mt-md-2 pb-2 row-no-padding title-divider-print-buttons">
  <div class="col-8">
    <ng-container *ngTemplateOutlet="title"></ng-container>
  </div>
  <div class="col-4 d-flex justify-content-end align-items-center">
    <ng-content select="cap-title-functionbar"></ng-content>
  </div>
</div>
